import { html } from "uhtml";
import { Customised } from "../custom-element.js";
import { locale, pageNumber } from "../../view-models/app-signals.js";
import { pageCount } from "../../view-models/page-signals.js";
import { locales } from "../../models/locales.js";

export class CassisChapterPosition extends Customised(HTMLElement) {
  static tagName = "cassis-chapter-position";
  signals() {
    const currentPage = pageNumber();
    const count = pageCount();
    return { currentPage, pageCount: count, locale: locale() };
  }
  render({ currentPage, pageCount, locale }) {
    return html`<span>${locales.chapterPositionPage[locale]} ${currentPage} ${
      locales.chapterPositionOf[locale]
    } ${pageCount}</span>`;
  }
}
CassisChapterPosition.define();
